import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";
import axiosAuth from "../../../src/core/api/axiosClientCustomAuth";

const initialState: any = {
  users: [],
  associatedUsersByBlock: [],
  userDetails: {},
  isLoadingAssociatedUsersByBlock: false,
  userbyEmail: {},
  isLoadingUserbyEmail: false,
  mfaInfo: {},
  isLoading: false,
  isLoadingUser: true,
  error: null,
  isLoggedIn: false,
  tokenData: {},
};

export const getUsers: any = createAsyncThunk(
  "content/getUsers",
  async ({
    PageNumber,
    pageSize,
    searchText = null,
    SortBy,
    SortDirection,
  }: any) => {
    const res = await axios.get(`/slpapp/User/getall`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });
    const data = await res.data;

    return data;
  }
);

export const getUserById: any = createAsyncThunk(
  "content/getUserDetails",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/User/UserbyId`, {
      params: { userId: id },
    });
    const data = await res.data;
    return data;
  }
);

export const verifySession: any = createAsyncThunk(
  "content/verify-session",
  async () => {
    const res = await axiosAuth.get(`/verify-session`);
    const data = await res.data?.tokenData;
    return data;
  }
);

export const getAssociatedUsersByBlock: any = createAsyncThunk(
  "content/getAssociatedUsersByBlock",
  async (params) => {
    const res = await axios.get(`/slpapp/User/AssociatedUsersByBlock`, {
      params,
    });

    const data = await res.data.data;
    return data;
  }
);

export const getuserbyemail: any = createAsyncThunk(
  "content/getuserbyemail",
  async () => {
    const res = await axios.get(`/slpapp/User/getuserInfobyemail`);
    const data = await res?.data?.data;
    return data;
  }
);

export const addUser: any = createAsyncThunk(
  "content/addUser",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/User`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.data;

    return data;
  }
);

export const editUser: any = createAsyncThunk(
  "content/editUser",
  async ({ payload, id }: any) => {
    const res = await axios.put(`/slpapp/User`, payload, {
      params: { userId: id },
    });

    // debugger;
    const data = await res.data;

    return data;
  }
);

export const deleteUser: any = createAsyncThunk(
  "content/deleteUser",
  async ({ id }: any) => {
    const res = await axios.delete(`/slpapp/User`, {
      params: { userId: id },
    });
    const data = await res.data.data;
    return data;
  }
);

export const updateMfaInfo: any = createAsyncThunk(
  "content/updateMfa",
  async ({ email, isMfaEnabled, isDMSMfaEnabled }: any) => {
    const res = await axios.put(
      `/slpapp/User/UserMfaInfo`,
      {},
      {
        params: { email, isMfaEnabled, isDMSMfaEnabled },
      }
    );
    const data = await res.data.data;

    return data;
  }
);

export const getUserMfaInfo: any = createAsyncThunk(
  "content/getUserMfaInfo",
  async () => {
    const res = await axios.get(`/slpapp/User/getUserMfaInfo`);
    const data = await res.data.data;
    return data;
  }
);

export const updateSecretCode: any = createAsyncThunk(
  "content/updateSecretCode",
  async ({ email, secretCode }: any) => {
    const res = await axios.put(
      `/slpapp/User/SecretCode`,
      {},
      {
        params: { email, secretCode },
      }
    );
    const data = await res.data;

    return data;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setIsLoggedInUser(state, action) {
      state.isLoggedIn = action.payload;
    },
    resetUserDetails(state, action) {
      state.userDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.isLoading = true;
      state.isLoadingUser = true;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.users = action.payload;
      state.isLoadingUser = false;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(verifySession.pending, (state) => {
      state.isLoadingUser = true;
    });
    builder.addCase(verifySession.fulfilled, (state, action) => {
      state.tokenData = action.payload.data;
      state.isLoadingUser = false;
    });
    builder.addCase(verifySession.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getUserById.pending, (state) => {
      state.isLoadingUser = true;
    });
    builder.addCase(getUserById.fulfilled, (state, action) => {
      state.userDetails = action.payload.data;
      state.isLoadingUser = false;
    });
    builder.addCase(getUserById.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAssociatedUsersByBlock.pending, (state) => {
      state.isLoadingAssociatedUsersByBlock = true;
    });
    builder.addCase(getAssociatedUsersByBlock.fulfilled, (state, action) => {
      state.isLoadingAssociatedUsersByBlock = false;
      state.associatedUsersByBlock = action.payload;
    });
    builder.addCase(getAssociatedUsersByBlock.rejected, (state, action) => {
      state.isLoadingAssociatedUsersByBlock = false;
      state.error = action.error.message;
    });

    builder.addCase(getuserbyemail.pending, (state) => {
      state.isLoadingUserbyEmail = true;
    });
    builder.addCase(getuserbyemail.fulfilled, (state, action) => {
      state.isLoadingUserbyEmail = false;
      state.userbyEmail = action.payload;
    });
    builder.addCase(getuserbyemail.rejected, (state, action) => {
      state.isLoadingUserbyEmail = false;
      state.error = action.error.message;
    });

    builder.addCase(addUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getUserMfaInfo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserMfaInfo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.mfaInfo = action.payload;
    });
    builder.addCase(getUserMfaInfo.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updateMfaInfo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateMfaInfo.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateMfaInfo.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setIsLoggedInUser, resetUserDetails } = userSlice.actions;
export default userSlice.reducer;
